import axios from 'axios';

const FALLBACK_API_SERVER = 'https://api.nostra.finance';
const API_SERVER = import.meta.env.VITE_APP_API_ENDPOINT || FALLBACK_API_SERVER;

export const callApiWithFallbacks = async (path: string, fallbackUrls: string[] = []) => {
  const normalizedPath = API_SERVER.endsWith('/') && path.startsWith('/') ? path.substring(1) : path;
  const normalizedFallbackPath = FALLBACK_API_SERVER.endsWith('/') && path.startsWith('/') ? path.substring(1) : path;

  if (API_SERVER === FALLBACK_API_SERVER) {
    return getWithFallbacks(`${API_SERVER}${normalizedPath}`, fallbackUrls);
  }

  return getWithFallbacks(
    `${API_SERVER}${normalizedPath}`,
    [`${FALLBACK_API_SERVER}${normalizedFallbackPath}`].concat(fallbackUrls),
  );
};

export const getWithFallbacks = async (url: string, fallbackUrls: string[] = []) => {
  let response;

  try {
    response = await axios.get(url);
  } catch (e) {
    if (!fallbackUrls.length) {
      throw e;
    }

    response = await getWithFallbacks(fallbackUrls[0], fallbackUrls.slice(1));
  }

  return response;
};
